import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import MetaTags from '../components/common/MetaTags';
import HeroSection from '../components/News/HeroSection';
import ArticleList from '../components/News/ArticleList';
import LocaleContext from '../contexts/LocaleContext';

import scrollToTarget from '../js/utils/scroll';
import NewsData from '../models/NewsData';
import { getNewsData } from '../js/api/articles';
import { toast } from 'react-toastify';

export default function NewsPage() {
  const { t } = useTranslation(['NewsPage']);
  const { locale } = useContext(LocaleContext);

  const [newsData, setNewsData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Scroll to the top after the page is loaded
  // This is mainly added to fix page view after redirect, the user views the page bottom onload
  useEffect(() => {
    const element = document?.getElementById('news-page');
    scrollToTarget(element);
  }, []);

  useEffect(() => {
    setIsLoading(true);
    getNewsData()
      .then((res) => {
        setNewsData(new NewsData(res.data));
      })
      .catch((e) => {
        toast.error('An error occurred, try again later');
        throw e;
      })
      .finally(() => setIsLoading(false));
  }, [locale]);

  return (
    <main className="news-page" id="news-page">
      <MetaTags title={t('pageTitle')} />
      {!isLoading && newsData && (
        <HeroSection image1={newsData?.heroImage1} image2={newsData?.heroImage2} />
      )}
      <ArticleList />
    </main>
  );
}
